module.exports = __webpack_public_path__ + "static/media/coin_stack_level_0.34bfa75f.svg";